/**
 * ScrapeKing Cyber Theme Colors
 * "Data Extraction Terminal" Aesthetic
 */

export const background = {
  default: '#0a0e14',           // Deep dark primary
  paper: '#151c24',             // Card/surface background
  paperElevation0: '#0f1419',   // Secondary background
  elevated: '#1a222d',          // Elevated surfaces
  disabledButton: '#2a3544',
};

export const action = {
  active: 'rgba(240, 244, 248, 0.56)',
  hover: 'rgba(0, 200, 224, 0.08)',
  selected: 'rgba(0, 200, 224, 0.16)',
  disabledBackground: 'rgba(42, 53, 68, 0.5)',
  focus: 'rgba(0, 200, 224, 0.12)',
  disabled: 'rgba(240, 244, 248, 0.3)',
  divider: '#2a3544',
};

// Terminal green for success
export const success = {
  main: '#00ff7f',
  dark: '#00cc66',
  light: '#4dffa1',
};

// Cyan for info/primary
export const info = {
  main: '#00c8e0',
  dark: '#007d8f',
  light: '#41e2f7',
};

// Amber for warning
export const warning = {
  main: '#ffb800',
  dark: '#cc9300',
  light: '#ffc426',
};

// Crimson for error
export const error = {
  main: '#ff0033',
  dark: '#cc0029',
  light: '#ff4d70',
};

export const secondary = {
  main: '#94a3b8',              // Muted text
  dark: '#64748b',             // Tertiary text
  light: '#f0f4f8',            // Primary text
  background: '#151c24',       // Surface
  border: '#2a3544',           // Border
  button: '#64748b',
  outline: '#3d4f66',
};

// Cyan accent as primary
export const primary = {
  main: '#00c8e0',
  dark: '#007d8f',
  light: '#41e2f7',
  hover: 'rgba(0, 200, 224, 0.08)',
  selected: 'rgba(0, 200, 224, 0.16)',
  focus: 'rgba(0, 200, 224, 0.12)',
  focusVisible: 'rgba(0, 200, 224, 0.4)',
  outlineBorder: 'rgba(0, 200, 224, 0.5)',
  list: '#1a222d',
};

// Cyan accent colors
export const cyan = {
  50: '#e0fcff',
  100: '#b8f5fe',
  200: '#7eedfc',
  300: '#41e2f7',
  400: '#1dd3ec',
  500: '#00c8e0',
  600: '#00a3b8',
  700: '#007d8f',
  800: '#005c6a',
  900: '#003d47',
  glow: 'rgba(0, 200, 224, 0.4)',
};

// Terminal green accent
export const green = {
  50: '#e6fff0',
  100: '#b3ffd6',
  200: '#80ffbb',
  300: '#4dffa1',
  400: '#26ff8c',
  500: '#00ff7f',
  600: '#00cc66',
  700: '#009950',
  800: '#00663a',
  900: '#003d24',
  glow: 'rgba(0, 255, 127, 0.35)',
};

export const colors = {
  white: '#f0f4f8',
  black: '#0a0e14',
  text: '#f0f4f8',                    // Primary text (light on dark)
  textSecondary: '#94a3b8',          // Secondary text
  textTertiary: '#64748b',           // Disabled/placeholder
  disabled: 'rgba(240, 244, 248, 0.3)',
  background,
  action,
  success,
  info,
  warning,
  error,
  secondary,
  primary,
  cyan,
  green,
};
